// extracted by mini-css-extract-plugin
export default {"opaqueheader":"SubpageHeader_opaqueheader__uHVDb"};